import { useState, useEffect } from "react";

export default function useShvaToken() {
  const [shvaToken, setShvaToken] = useState("");

  useEffect(() => {
    const url = new URL(window.location.href);
    const shva = url.searchParams.get("shva");

    if (shva) {
      localStorage.setItem("shva", decodeURIComponent(shva).replace(" ", "+"));
      localStorage.setItem("sourceName", "PowerBI UI");
    }

    const stored = localStorage.getItem("shva");
    if (stored) setShvaToken(stored);
  }, []);

  return shvaToken;
}
